import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import cx from 'classnames';
import cs from '../../../components/commonStyle.css';

// Confirms a car scan override and captures the reason for it.
// The reason is mandatory: an override with no recorded justification is
// indistinguishable from a trip that passed the photo check normally, which
// defeats the point of recording it at all.
const OverrideScanModal = ({
  show,
  onHide,
  onConfirm,
  reason,
  onReasonChange,
  submitting,
  error,
  className,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    animation={false}
    backdrop="static"
    keyboard={false}
    className={cx('remarkModal languageModalContainer languageModalRTL', className)}
  >
    <Modal.Header closeButton className={cx(cs.fontDMSerif)}>
      <span>Override car scan requirement</span>
    </Modal.Header>
    <Modal.Body>
      <p style={{ fontSize: 15, lineHeight: 1.5 }}>
        This lets the trip be completed without a full set of before and after
        photographs. Use it only when the guest genuinely cannot capture them.
        The override is recorded against the reservation with your name.
      </p>
      <label htmlFor="overrideReason" style={{ display: 'block', marginTop: 12, fontWeight: 600 }}>
        Reason
      </label>
      <textarea
        id="overrideReason"
        value={reason}
        onChange={e => onReasonChange(e.target.value)}
        disabled={submitting}
        rows={3}
        style={{ width: '100%', padding: 8 }}
        placeholder="e.g. guest phone battery dead, unable to photograph at drop-off"
      />
      {error && (
        <div style={{ color: '#c0392b', marginTop: 10, wordBreak: 'break-word' }}>
          {error}
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-secondary" onClick={onHide} disabled={submitting}>
        Cancel
      </button>
      <button
        className="btn btn-primary"
        onClick={onConfirm}
        disabled={submitting || !reason.trim()}
      >
        {submitting ? 'Overriding…' : 'Confirm override'}
      </button>
    </Modal.Footer>
  </Modal>
);

OverrideScanModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  reason: PropTypes.string,
  onReasonChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
};

OverrideScanModal.defaultProps = {
  reason: '',
  submitting: false,
  error: '',
  className: '',
};

export default OverrideScanModal;
